export default __webpack_public_path__ + "static/media/slobozia-card.aee2e608.png";